import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
} from "react";
import { AgCharts } from "ag-charts-react";
import { Container, Box, Stack, Paper } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useWindowDimensions } from "./useWindowDimensions.jsx";
import { ScenarioUrl_spec, ftchPlus, getOptions } from "./Account_urls.jsx";
import { CrumbToggleScenario } from "../Components/CrumbToggles.jsx";

import {
  faChevronLeft,
  faChevronRight,
  faCircleChevronLeft,
  faCircleChevronRight,
  faExpand,
} from "@fortawesome/free-solid-svg-icons";


import ToggleSet from "../Components/ToggleSet.jsx";
import { myOwnFP_chart_palette2 } from "../Components/Charts.jsx"
import { isEmpty } from 'lodash';
import { ErrorBar } from "../Components/ErrorBar.jsx";
import { HelpChart } from "../Dialogs/Help/Help_Charts.jsx";
import HelpIcon from "../Dialogs/Help/HelpIcon.jsx";
import { chevronColor, iconSize } from "./GridRenderers.jsx";
import CloseIcon from "../Components/CloseIcon.jsx";
import { ChartExport } from "../Components/ChartExport.jsx";
import { GridChartIcon, ChartIcon } from "../Dialogs/GridChart/GridChartIcon.jsx";
import GridChartViewPort from "../Dialogs/GridChart/GridChartViewPort.jsx";
import { GridCsv } from "../Components/GridCsv.jsx";
import { UpdateAxes, UpdateSeries } from "./Chart.jsx";
import { Input_Comment_Def } from "../Components/Inputs/Input_Name.jsx";


import {
  LineSeriesModule,
  BarSeriesModule,
  NumberAxisModule,
  CategoryAxisModule,
  LegendModule,
  ModuleRegistry
} from 'ag-charts-community';

ModuleRegistry.registerModules([
  LineSeriesModule,
  BarSeriesModule,
  NumberAxisModule,
  CategoryAxisModule,
  LegendModule,
]);



const ClientChartId = ({
  clientJson,
  type,
  args,
  dataset,
  acct,
  onLeft = null,
  onRight = null,
  onClose,
  width = 1700,
  height = 800,
  onError,
  scen_name = null,
  onSetChange = null,
  dataSet_ = null,
  client_ = null,
  onGridIconClick = null,
  gridShow = false,
  showDups = true,
}) => {
  const { winHeight, winWidth } = useWindowDimensions();
  const chartRef = useRef(null);
  const gridRef = useRef(null);


  const clientData = useRef(null);
  const [clients, setClients] = useState([]);
  const [client, setClient] = useState();
  const [dataSets, setDataSets] = useState([]);
  const [dataSet, setDataSet] = useState();

  // const [chartData, setChartData] = useState();
  const [chartTitle, setChartTitle] = useState();
  // const [chartSubtitle, setChartSubtitle] = useState();
  // const [chartSeries, setChartSeries] = useState([]);
  // const [chartAxes, setChartAxes] = useState({});
  const [chartOptions, setChartOptions] = useState({})
  const [expand, setExpand] = useState(false);
  const [errmsg, setErrmsg] = useState("")


  const getTitle = () => {
    return chartTitle;
  };
  // const getSubtitle = () => {
  //   return chartSubtitle;
  // };

  // const getSeries = () => {
  //   return chartSeries
  // };

  // const getAxes = () => {
  //   return chartAxes
  // };

  // const getData = () => {
  //   return chartData;
  // };

  const getClient = () => {
    return client;
  };

  const setOptions = (ti, st, d, a, s) => {
    setChartOptions({
      title: ti,
      subtitle: st,
      axes: a,
      data: d,
      series: s,
      theme: {
        palette: myOwnFP_chart_palette2,
      },
      tooltip: {
        mode: "single",
      },
      height: expand ? winHeight - 35 * 4 : height,
      width: expand ? winWidth - 66 * 4 : width,
      legend: { position: "bottom" },
    })
  }

  const Update = (cl, ds) => {
    setClient(cl);
    setDataSet(ds);
    if (clientData.current && clientData.current[cl] && clientData.current[cl][ds]) {

      // setChartData(clientData.current[cl][ds].Data);
      // setChartSubtitle({ "text": scenName() + " : " + cl + " : " + ds })
      setChartTitle(clientData.current[cl][ds].Title);
      let noscen = clientData.current[cl][ds].SubTitle.text === "-na-" ? true : false
      let ca = UpdateAxes(clientData.current[cl][ds].Axes);
      // console.log(ca)
      if (ca) {
        // setChartAxes(ca)
        let cs = UpdateSeries(clientData.current[cl][ds].Series)
        // setChartSeries(cs);
        setOptions(clientData.current[cl][ds].Title,
          { "text": (noscen ? "" : (scenName() + " : ")) + cl + " : " + ds },
          clientData.current[cl][ds].Data,
          ca,
          cs)
      } else {
        // setChartAxes({})
        // setChartSeries(clientData.current[cl][ds].Series);
        setOptions(clientData.current[cl][ds].Title,
          { "text": (noscen ? "" : (scenName() + " : ")) + cl + " : " + ds },
          clientData.current[cl][ds].Data,
          {},
          clientData.current[cl][ds].Series)
      }

    } else {
      // setChartData(null);
      // setChartSeries([]);
      // setChartSubtitle("");
      // setChartTitle("");
      // setChartAxes({})
      setOptions({ text: "" },
        { text: "" },
        [],
        {},
        [])
    }
  };

  // this is for when we have all the data but we want to change then name or currency (ds)
  useEffect(() => {
    // console.log("UE C/DS")
    // console.log(client_)
    Update(client_, dataSet_)
  }, [client_, dataSet_, expand])

  useEffect(() => {
    // console.log("UE C/DS")
    // console.log(client_)
    Update(client, dataSet)
  }, [expand])



  useEffect(() => {
    setErrmsg("")
  }, [type, args]);

  // useEffect(() => { }, [client, dataSet, chartData]);

  // this is when we have a whole new dataset (new chart)
  useEffect(() => {
    setErrmsg("")
    if (dataset !== null) {
      console.log(dataset)
      if (dataset.Clients !== null && dataset.DataSets !== null) {
        clientData.current = dataset.ClientData;
        setClients(dataset.Clients);
        setDataSets(dataset.DataSets);
        // console.log("UE, dataset")
        Update(dataset.Clients[0], dataset.DataSets[0]);
      }
    }
  }, [dataset]);


  // const chartGrossListener = useCallback((e) => {
  //   getData2();
  // }, []);

  const btnClientChanged = (value) => {
    // console.log("chart client changed: " + value);
    if (onSetChange !== null) {
      onSetChange(value, dataSet)
    } else {
      // console.log("btnClient")
      Update(value, dataSet);
    }

  };

  const btnDataSetChanged = (value) => {
    // console.log("chart dataset changed: " + value);
    if (onSetChange !== null) {
      onSetChange(client, value)
    } else {
      // console.log("btnDataSet")
      Update(client, value);
    }
  };

  const chartRefFn = () => {
    return chartRef
  }

  const gridRefFn = () => {
    return gridRef
  }


  // const onGridIcon = (v) => {
  //   //setGridShow(v)
  //   onGridIconClick(v)
  // }

  const scenName = () => {
    return (scen_name !== null ? scen_name : clientJson.Scenario.label)
  }

  const onChange = (defC, comment) => {

  }
  return (
    <Container maxWidth="false" sx={{ mx: 2, my: 2 }}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} sx={{ alignContent: "center" }}>
          <div>
            <Stack direction="row" spacing={2}>
              <CrumbToggleScenario
                key={"client-chartID-crT"}
                set={clients}
                current={client}
                onChange={btnClientChanged}
                clientJson={clientJson}
                scen_name={scen_name}
              />
              <ToggleSet
                key={"client-chartID-ts"}
                set={dataSets}
                current={dataSet}
                onChange={btnDataSetChanged}
              />

              {showDups && onLeft && (
                <Stack direction="row">
                  <FontAwesomeIcon
                    color={chevronColor}
                    size="2xl"
                    icon={faCircleChevronLeft}
                    onClick={onLeft}
                  />
                </Stack>
              )}
              {showDups && onRight && (
                <Stack direction="row">
                  <FontAwesomeIcon
                    color={chevronColor}
                    size="2xl"
                    icon={faCircleChevronRight}
                    onClick={onRight}
                  />
                </Stack>
              )}
            </Stack>
          </div>


          <Box
            sx={{
              display: "flex",
              flexGrow: 1,
              alignContent: "center",
              justifyContent: "flex-end",
            }}
          >

            <Stack direction="row" spacing={2}>
              {!gridShow && (
                <>
                  <GridChartIcon
                    onClick={(v) => onGridIconClick(true)}
                  />
                  <ChartExport
                    filename={"MyOwnFP " + scenName() + " " + client + " " + dataSet}
                    titleFn={getTitle}
                    chartRefFn={chartRefFn}
                  />
                </>
              )}
              {gridShow && dataSet !== "" && chartTitle && (
                <>
                  <ChartIcon
                    onClick={(v) => onGridIconClick(false)}
                  />

                  <GridCsv
                    filename={"MyOwnFP " + scenName() + " " + client + " " + dataSet + " " + chartTitle.text}
                    name={chartTitle.text}
                    scenario={scenName()}
                    client={client}
                    dataset={dataSet}
                    gridRefFn={gridRefFn}
                  />
                </>
              )}

              <HelpIcon mt={-1}
                show={showDups} />
              <Stack>
                <Box sx={{ mt: 1, mr: 2 }}>
                  <FontAwesomeIcon
                    size={iconSize}
                    color="lightgray"
                    icon={faExpand}
                    onClick={() => setExpand(!expand)}
                  />
                </Box>
              </Stack>
              <CloseIcon mt={-.5}
                show={showDups}
                onClick={onClose}
              />
            </Stack>
          </Box>
        </Stack>
        <Paper>
          {gridShow && (
            <GridChartViewPort
              show={gridShow}
              clientData={clientData.current}
              client_={client}
              dataSet_={dataSet}
              height={expand ? winHeight - 35 * 4 : height}
              gridRef={gridRef}
            />
          )}
          {!gridShow && dataSet !== null && chartTitle !== null && !(isEmpty(chartOptions)) && (
            <Stack sx={{ pb: 5 }}>


              <AgCharts
                ref={chartRef}
                options={chartOptions}
              />
              <Input_Comment_Def
                defC={true}
                comment={"xx"}
                defComment={"xxxx"}
                onChange={onChange}
                button={"Save"}
              />
              <ErrorBar error={errmsg} />
              <HelpChart chart={type} arg={args} />
            </Stack>
          )}
        </Paper>
      </Stack >
    </Container >
  );
};

export default ClientChartId;
